import {
  ProjectActionTypes,
  IFetchProjectsPayload,
  IFetchProjectsSuccessResponseBody,
  IChangeSelectedProjectsPayload,
  ISetSearchTextPayload,
  ICreateProjectPayload,
  IDeleteProjectsPayload,
  IDeleteProjectsSuccessPayload,
  IUpdateProjectsPayload,
  IUpdateProjectsSuccessResponseBody,
  IUpdateProjectTitlePayload,
  IUpdateProjectTitleSuccessPayload,
  ICreateClipsPayload,
  IStartBulkExportationPayload,
} from './types'

export const fetchProjects = (payload: IFetchProjectsPayload) => ({
  type: ProjectActionTypes.FETCH_PROJECTS,
  payload,
})

export const fetchProjectsSuccess = (payload: IFetchProjectsSuccessResponseBody) => ({
  type: ProjectActionTypes.FETCH_PROJECTS_SUCCESS,
  payload
})

export const fetchProjectsFailure = () => ({
  type: ProjectActionTypes.FETCH_PROJECTS_FAILURE,
})

export const createProject = (payload: ICreateProjectPayload) => ({
  type: ProjectActionTypes.CREATE_PROJECT,
  payload
})

export const createProjectSuccess = () => ({
  type: ProjectActionTypes.CREATE_PROJECT_SUCCESS,
})

export const createProjectFailure = () => ({
  type: ProjectActionTypes.CREATE_PROJECT_FAILURE,
})

export const changeSelectedProjects = (payload: IChangeSelectedProjectsPayload) => ({
  type: ProjectActionTypes.CHANGE_SELECTED_PROJECTS,
  payload
})

export const unselectProjects = () => ({
  type: ProjectActionTypes.UNSELECT_PROJECTS,
})

export const resetShouldCheckAutoFillGrid = () => ({
  type: ProjectActionTypes.RESET_SHOULD_CHECK_AUTO_FILL_GRID,
})

export const resetShouldCheckAutoFillList = () => ({
  type: ProjectActionTypes.RESET_SHOULD_CHECK_AUTO_FILL_LIST,
})

export const setShouldCheckAutoFill = () => ({
  type: ProjectActionTypes.SET_SHOULD_CHECK_AUTO_FILL,
})

export const setListActive = () => {
  window.Checksub.cookies.set('listActive', 'true', { path: '/' })

  return { type: ProjectActionTypes.SET_LIST_ACTIVE }
}

export const setGridActive = () => {
  window.Checksub.cookies.set('listActive', 'false', { path: '/' })

  return { type: ProjectActionTypes.SET_GRID_ACTIVE }
}

export const deleteProjects = (payload: IDeleteProjectsPayload) => ({
  type: ProjectActionTypes.DELETE_PROJECTS,
  payload,
})

export const deleteProjectsFailure = () => ({
  type: ProjectActionTypes.DELETE_PROJECTS_FAILURE,
})

export const deleteProjectsSuccess = (payload: IDeleteProjectsSuccessPayload) => ({
  type: ProjectActionTypes.DELETE_PROJECTS_SUCCESS,
  payload
})

export const updateProjects = (payload: IUpdateProjectsPayload) => ({
  type: ProjectActionTypes.UPDATE_PROJECTS,
  payload
})

export const updateProjectsSuccess = (payload: IUpdateProjectsSuccessResponseBody) => ({
  type: ProjectActionTypes.UPDATE_PROJECTS_SUCCESS,
  payload
})

export const updateProjectsFailure = () => ({
  type: ProjectActionTypes.UPDATE_PROJECTS_FAILURE,
})


export const setSearchText = (payload: ISetSearchTextPayload) => ({
  type: ProjectActionTypes.SET_SEARCH_TEXT,
  payload,
})

export const updateProjectTitle = (payload: IUpdateProjectTitlePayload) => ({
  type: ProjectActionTypes.UPDATE_PROJECT_TITLE,
  payload
})

export const updateProjectTitleSuccess = (payload: IUpdateProjectTitleSuccessPayload) => ({
  type: ProjectActionTypes.UPDATE_PROJECT_TITLE_SUCCESS,
  payload
})

export const updateProjectTitleFailure = () => ({
  type: ProjectActionTypes.UPDATE_PROJECT_TITLE_FAILURE,
})

export const createClips = (payload: ICreateClipsPayload) => ({
  type: ProjectActionTypes.CREATE_CLIPS,
  payload
})

export const createClipsSuccess = () => ({
  type: ProjectActionTypes.CREATE_CLIPS_SUCCESS,
})

export const createClipsFailure = () => ({
  type: ProjectActionTypes.CREATE_CLIPS_FAILURE,
})

export const startBulkExportation = (payload: IStartBulkExportationPayload) => ({
  type: ProjectActionTypes.START_BULK_EXPORTATION,
  payload
})

export const startBulkExportationSuccess = () => ({
  type: ProjectActionTypes.START_BULK_EXPORTATION_SUCCESS,
})

export const startBulkExportationFailure = () => ({
  type: ProjectActionTypes.START_BULK_EXPORTATION_FAILURE,
})
